import React, {useEffect} from 'react';
import styled from 'styled-components';
import {ContentBox, Contents} from "../../components";
import {useRecoilState} from "recoil";
import {subMenuState} from "../../../state";
import AuthorProfile from "./SubPage/AuthorProfile";
import AccountSettiong from "./SubPage/AccountSettiong";

const Profile = () => {
    const [subMenu, setSubMenu] = useRecoilState(subMenuState);
    useEffect(() => {
        setSubMenu("Author Profile");
    }, []);
    return(
  <Container>
    <ContentBox>
        {
            subMenu === "Author Profile" ?  <AuthorProfile/> : <AccountSettiong/>
        }
    </ContentBox>
  </Container>
)

}
export default Profile;

const Container = styled.div`

`;
